// ─── Brand Colors ───────────────────────────────────────────────────────────
export const BRAND = {
  blue: "#29ABE2",
  blueDark: "#1a8bbf",
  green: "#8DC63F",
  greenDark: "#6fa830",
  gray: "#8C9BA8",
};

// ─── Theme Tokens ───────────────────────────────────────────────────────────
export const THEMES = {
  dark: {
    bg: "#0a0f15",
    surface: "#0f1923",
    surfaceAlt: "#131f2e",
    border: "#1c2e42",
    borderLight: "#1a2a3a",
    text: "#e8f4ff",
    textSub: "#7a99b8",
    textMuted: "#3d5c78",
    inputBg: "#0d1a27",
    sidebarBg: "#0c1620",
    topbarBg: "#0c1620",
    shadow: "0 4px 24px rgba(0,0,0,0.5)",
    modalBg: "#0f1923",
  },
  light: {
    bg: "#f0f5fa",
    surface: "#ffffff",
    surfaceAlt: "#f8fbff",
    border: "#d4e3f0",
    borderLight: "#e2eef8",
    text: "#0f2540",
    textSub: "#4a6c88",
    textMuted: "#8aaccc",
    inputBg: "#f5f9fd",
    sidebarBg: "#ffffff",
    topbarBg: "#ffffff",
    shadow: "0 4px 24px rgba(41,171,226,0.08)",
    modalBg: "#ffffff",
  },
};

// ─── Staff ──────────────────────────────────────────────────────────────────
export const STAFF = ["Bibek", "Biraj", "Ben"];

export const STAFF_COLORS = {
  Bibek: BRAND.blue,
  Biraj: BRAND.green,
  Ben: "#f59e0b",
};

export const STAFF_EMAILS = {
  "bibekkshetri@netsavetax.com": "Bibek",
  "birajpandey@netsavetax.com": "Biraj",
  "ben.karki@netsavetax.com": "Ben",
};

// ─── Status Pipeline ────────────────────────────────────────────────────────
export const STATUS_FLOW = [
  "Not Started",
  "Engagement Sent",
  "Engagement Signed",
  "Tax Return in Progress",
  "Extension Filed",
  "Invoice Pending",
  "Completed",
];

export const STATUS_META = {
  "Not Started": {
    bg: (th) => (th === "dark" ? "#111820" : "#f0f5fa"),
    text: "#6b7c93",
    border: "#6b7c93",
    icon: "○",
  },
  "Engagement Sent": {
    bg: (th) => (th === "dark" ? "#0e2040" : "#e8f4fd"),
    text: BRAND.blue,
    border: BRAND.blue,
    icon: "✉",
  },
  "Engagement Signed": {
    bg: (th) => (th === "dark" ? "#0e2818" : "#edfaf0"),
    text: BRAND.green,
    border: BRAND.green,
    icon: "✍",
  },
  "Tax Return in Progress": {
    bg: (th) => (th === "dark" ? "#2a1e00" : "#fff9e6"),
    text: "#f59e0b",
    border: "#f59e0b",
    icon: "⚙",
  },
  "Extension Filed": {
    bg: (th) => (th === "dark" ? "#1a1030" : "#f3edff"),
    text: "#e85d04",
    border: "#e85d04",
    icon: "📋",
  },
  "Invoice Pending": {
    bg: (th) => (th === "dark" ? "#17103a" : "#f0edff"),
    text: "#a78bfa",
    border: "#a78bfa",
    icon: "💳",
  },
  Completed: {
    bg: (th) => (th === "dark" ? "#0e2818" : "#edfaf0"),
    text: BRAND.green,
    border: BRAND.green,
    icon: "✓",
  },
  // Legacy statuses for backwards compat
  Signed: {
    bg: (th) => (th === "dark" ? "#0e2818" : "#edfaf0"),
    text: BRAND.green,
    border: BRAND.green,
    icon: "✓",
  },
  Submitted: {
    bg: (th) => (th === "dark" ? "#17103a" : "#f0edff"),
    text: "#a78bfa",
    border: "#a78bfa",
    icon: "📤",
  },
  Paid: {
    bg: (th) => (th === "dark" ? "#0b2218" : "#ebfaf1"),
    text: "#22c55e",
    border: "#22c55e",
    icon: "✓",
  },
  "Not Paid": {
    bg: (th) => (th === "dark" ? "#2a0e0e" : "#fff0f0"),
    text: "#f87171",
    border: "#f87171",
    icon: "!",
  },
};

// ─── Entity Types ───────────────────────────────────────────────────────────
export const ENTITY_TYPES = [
  "LLC",
  "S-Corp",
  "C-Corp",
  "Partnership",
  "Sole Prop",
  "Non-Profit",
  "Trust",
];

export const QB_SERVICES = [
  { id:"BOI",        name:"BOI services",                         rate:0 },
  { id:"BOOKKEEP",   name:"Bookkeeping Services",                 rate:0 },
  { id:"CONSULT",    name:"Consulting Services",                  rate:0 },
  { id:"CUSTOM",     name:"Custom Amount",                        rate:0 },
  { id:"ORG",        name:"Organization Formation/Dissolving",    rate:0 },
  { id:"PAYROLL",    name:"Payroll Services",                     rate:0 },
  { id:"QUARTERLY",  name:"Quarterly Estimated Taxes",            rate:0 },
  { id:"QBSUB",      name:"QuickBooks and Payroll Subscription",  rate:0 },
  { id:"SALESTAX",   name:"Sales Tax Filing",                     rate:0 },
  { id:"TAXNOTICE",  name:"Tax Notice Resolution",                rate:0 },
  { id:"TAXPLAN",    name:"Tax Planning",                         rate:0 },
  { id:"TAXPREP",    name:"Tax Preparation Service",              rate:0 },
];

export const STAFF_SIGNATURES = {
  Bibek: "Best regards,\nBibek Panday Kshetri, EA\nNetSave Tax & Accounting, LLC\n📞 (619) 555-0101 · 📧 bibek@netsave.com\n🌐 www.netsavetax.com",
  Biraj: "Best regards,\nBiraj Kshetri, CPA\nNetSave Tax & Accounting, LLC\n📞 (619) 555-0102 · 📧 biraj@netsave.com\n🌐 www.netsavetax.com",
  Ben:   "Best regards,\nBen Williams\nNetSave Tax & Accounting, LLC\n📞 (619) 555-0103 · 📧 ben@netsave.com\n🌐 www.netsavetax.com",
};
